import BaseInfo from "./BaseInfo";
import options from "../../common/enum/options";
import {getUUID, deepObjectMerge} from "@/common/utils.js";
import i18n from "@/locales/i18n";
export default class CheckBoxInfo extends BaseInfo {
  constructor(options) {
    super(options);
    // 类型
    this.type = "checkbox";
    // 是否含其它选项，2 标示不含，1标示含有
    this.custom_ques = 2;
    // 单选选项
    this.items = [];

    // 正确答案
    this.correct_answer = [];

    // 选项最小个数，若无限制可不传
    this.min = "";

    // 选项最大个数，若无限制可不传
    this.max = "";
    this.replys = [];
    //选项列表
    this.detail.list = [
      {
        key: "A",
        value: i18n.t("lang.k_870001"),
        is_answer: 0,
        imgUrl: "",
        kid: getUUID(),
      },
      {
        key: "B",
        value: i18n.t("lang.k_870002"),
        is_answer: 0,
        imgUrl: "",
        kid: getUUID(),
      },
    ];
    deepObjectMerge(this, options);
    //正确答案
    this.correct_answer = [];
    this.detail.list.forEach((item) => {
      if (item.is_answer == 1) {
        this.correct_answer.push(item.key);
      }
    });
  }
  //删除选项
  delOption(index) {
    this.detail.list.splice(index, 1);
    this.detail.list.forEach((item, index) => {
      item.key = options[index];
    });
    this.correct_answer = [];
    this.detail.list.forEach((item) => {
      if (item.is_answer == 1) {
        this.correct_answer.push(item.key);
      }
    });
  }
  //增加选项
  addOption(option) {
    if (this.detail.list.length > 29) {
      return;
    }
    this.detail.list.push(
      Object.assign(
        {
          key: options[this.detail.list.length],
          value: `${i18n.t("lang.k_870003")}${this.detail.list.length + 1}`,
          is_answer: 0,
          imgUrl: "",
          kid: getUUID(),
        },
        option
      )
    );
  }
  //设置正确答案
  setCurrentAnswer(answer) {
    this.correct_answer =
      typeof answer === "string" ? answer.split(",").sort() : answer;
    this.detail.list.forEach((item) => {
      if (this.correct_answer.includes(item.key)) {
        item.is_answer = 1;
      } else {
        item.is_answer = 0;
      }
    });
  }
  //获取当前题对错
  getResult() {
    return (
      [...this.replys].sort().toString() ==
      [...this.correct_answer].sort().toString()
    );
  }
}
